<template>
  <div class="layout-column">
    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
      <lx-btn :disabled="isDisabled"
              icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('FORMS_DIVERSE.GENETIC_VARIANT_ADD_NEW_GENETIC_VARIANT')"
              :label="$t('FORMS_DIVERSE.GENETIC_VARIANT_ADD_NEW_GENETIC_VARIANT')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              classes="text-none"
              @click="addNewItem(path)"
      ></lx-btn>
    </div>

    <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

    <div :key="index" v-for="(item, index) in model"
         class="layout-row pa-0 ma-2"
         :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
         style="border-radius:4px;"
         :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

      <div class="layout-row layout-wrap flex px-3">
        <div class="flex-gt-sm-33 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.datum'"
                               :ref="path + '.' + index + '.datum'"
                               :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_lesser_than_death:[deathDate,model[index].datum_genauigkeit]}"
                               v-slot="{ errors }">
            <lx-datepicker
                :color="compColor.textInput"
                :name="path + '.' + index + '.datum'"
                :label="$t('FORMS_DIVERSE.GENETIC_VARIANT_DATE') + ' *'"
                class="mr-1 mb-0"
                @input="setDateAccuracyAfterDate(index)"
                :disabled="isDisabled"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error="errors[0]"
                v-model="item.datum"
            ></lx-datepicker>
          </validation-provider>
        </div>

        <!-- Datumsgenauigkeit Datum genetische Variante -->

        <div class="flex-gt-sm-33 flex-100 px-2 py-3 layout-row">
          <validation-provider tag="div"
                               class="flex"
                               :name="path + '.' + index + '.datum_genauigkeit'"
                               :ref="path + '.' + index + '.datum_genauigkeit'"
                               rules="required"
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              :label="$t('FORMS_DIVERSE.GENETIC_VARIANT_DATE_ACCURACY') + ' *'"
              v-model="model[index].datum_genauigkeit"
              :items="DateAccuracyTypes"
              :disabled="isDisabled"
              outlined
              class="mb-0"
              @change="validateDateAfterChangeOfAccuracy(index)"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>

          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 mr-3 ml-2"
                   :class="{'mt-1': !denseFields}"
                   style="cursor: pointer;">
                <v-icon :color="compColor.prime" medium>info</v-icon>
              </div>
            </template>
            <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
          </v-tooltip>
        </div>

        <div class="flex-gt-sm-33 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.bezeichnung'"
                               :ref="path + '.' + index + '.bezeichnung'"
                               rules="trim_string"
                               v-slot="{ errors }">
            <long-input
              :color="compColor.primeColor"
              :name="path + '.' + index + '.bezeichnung'"
              :label="$t('FORMS_DIVERSE.GENETIC_VARIANT_DESCRIPTION') + ' *'"
              v-model="item.bezeichnung"
              :hide-details="!errors || errors.length <= 0"
              :disabled="isDisabled"
              :dense="denseFields"
              class="mb-0"
              :error="errors[0]"
            ></long-input>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-33 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.auspraegung'"
                               :ref="path + '.' + index + '.auspraegung'"
                               :rules="{required: !model[index].sonstige_auspraegung}"
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              :label="formatRequiredLabelOfExpression(index,'FORMS_DIVERSE.GENETIC_VARIANT_EXPRESSION')"
              v-model="item.auspraegung"
              :items="geneticExpressions"
              outlined
              class="mb-0"
              @change="changeExpression(index, 'sonstige_auspraegung')"
              :disabled="isDisabled"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <div class="flex-gt-sm-66 flex-100 px-2 py-3 layout-row">
          <span class=" mr-4 pt-2" :style="{'color': compColor.primeColor}">{{ $t('OR') }}</span>
          <validation-provider tag="div"
                               :name="path + '.' + index + '.sonstige_auspraegung'"
                               :ref="path + '.' + index + '.sonstige_auspraegung'"
                               :rules="{required: !model[index].auspraegung, trim_string: true}"
                               class="flex"
                               v-slot="{ errors }">
            <long-input
              :color="compColor.primeColor"
              :name="path + '.' + index + '.sonstige_auspraegung'"
              :label="formatRequiredLabelOfExpression(index,'FORMS_DIVERSE.GENETIC_VARIANT_OTHER_EXPRESSION')"
              v-model="item.sonstige_auspraegung"
              :disabled="isDisabled"
              class="mb-0"
              @input="changeExpression(index, 'auspraegung')"
              :dense="denseFields"
              :error="errors[0]"
            ></long-input>
          </validation-provider>
        </div>
      </div>

      <div class="layout-column layout-align-center-center px-3"
           :class="{'grey lighten-2': !compColor.isInDarkMode}"
           :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
        <lx-btn @click="deleteItem(path, index, path + '.' + index + '.bezeichnung')"
                :color="compColor.primeColor"
                :iconColor="'white'"
                iconSize="21"
                :width="35"
                :height="35"
                :disabled="isDisabled" icon="delete_forever"></lx-btn>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'

export default {
  name: "GenetischeVariante",
  mixins: [metaData, utils],
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    path: {
      type: String
    },
    addNewItem: {
      type: Function
    },
    deleteSelectedItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    }
  },
  data () {
    return {
      model: [],
      geneticExpressions: null,
      DateAccuracyTypes: null
    }
  },
  created () {
    this.geneticExpressions = this.formsMetaData.GeneticExpressions
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * Set label required if no expression or other expression is filled
     *
     * @param index The index of selected array element
     * @param text The text to localize
     * @returns {VueI18n.TranslateResult}
     */
    formatRequiredLabelOfExpression (index, text) {
      let label = this.$t(text)

      // if no element is selected, set * on iknr and ersatzkode
      if (!this.model[index].auspraegung && !this.model[index].sonstige_auspraegung) {
        label += ' *'
      }

      return label
    },

    /**
     * Delete alternative value after setting value (auspraegung <> sonstige_auspraegung)
     *
     * @param index The index of selected array element
     * @param value The name of value to delete
     */
    changeExpression (index, value) {
      this.$delete(this.model[index], value)
    },

    /**
     * Validate date after changing date accuracy
     *
     * @param index The index of selected classification
     */
    validateDateAfterChangeOfAccuracy (index) {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.' + index + '.datum'] && this.$refs[this.path + '.' + index + '.datum'][0]) {
          this.$refs[this.path + '.' + index + '.datum'][0].validate()
        }
      })
    },

    /**
     * Delete selected element of genetic variant and trigger validator for saving
     */
    deleteItem (path, index, field) {
      this.deleteSelectedItem(path, index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Set date accuracy per default after date input
     *
     * @param index
     */
    setDateAccuracyAfterDate (index) {
      // set datum_genauigkeit if not exists after changing datum in datepicker
      if (this.model[index] && this.model[index].datum && !this.model[index].datum_genauigkeit) {
        this.$set(this.model[index], 'datum_genauigkeit', 'E')
      }
    }
  },
  computed: {
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
